// Cognito Configuration
// These values are output by CDK after deployment
// Update these after first deployment, then redeploy

const config = {
  // Replace with your values from CDK outputs
  userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_Xb1lCcyNq',
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '1rju6fmfleudobgp43rlnpfh7',
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
};

export default config;
